import Block from '@/components/Block'
import { Stack } from '@/components/Layout'
import { coreLayoutSection, rbp } from '@/constants/measured-scope'
import { getConfig } from '@/lib/config'
import { GoogleAdBannerContent } from '@/shared/api-generated-types'
import { useMediaQuery } from '@react-hookz/web'
import Script from 'next/script'
import { useEffect, useRef } from 'react'

export interface Props {
  id: string
  content: GoogleAdBannerContent
}

const GoogleAdBannerBlock = ({ id, content }: Props): JSX.Element | null => {
  const adContainerRef = useRef(null)
  const isCalledRef = useRef(false)

  const { publicRuntimeConfig } = getConfig()
  const isTabletAndAbove = useMediaQuery(`only screen and (min-width: ${rbp.md})`)

  const containerId = `div-gpt-ad-row`
  const containerSize: [number, number] = isTabletAndAbove
    ? [content.sizes.desktop.width, content.sizes.desktop.height]
    : [content.sizes.mobile.width, content.sizes.mobile.height]

  useEffect(() => {
    try {
      if (!adContainerRef.current || isCalledRef.current === true) return
      isCalledRef.current = true

      window.googletag = window.googletag || { cmd: [] }

      window.googletag.cmd.push(() => {
        // @ts-ignore
        window.googletag
          .defineSlot(publicRuntimeConfig.googlePublisherTag.slotId, containerSize, containerId)
          .setTargeting('pos', ['webapp'])
          .addService(googletag.pubads())
        googletag.pubads().enableSingleRequest()
        googletag.enableServices()
      })

      googletag.cmd.push(() => {
        googletag.display(containerId)
      })
    } catch (error) {
      console.error('GoogleAdBannerError', error)
    }
  }, [adContainerRef.current, isCalledRef.current])

  return (
    <Block key={id} id={id} className={coreLayoutSection} spacing="sm">
      <Stack x alignItems="center" justifyContent="center">
        <div ref={adContainerRef} id={containerId}></div>
      </Stack>
      <Script async strategy="afterInteractive" src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" />
    </Block>
  )
}
export default GoogleAdBannerBlock
